import { createFileRoute } from "@tanstack/react-router";
import { PaginaCompartir } from "@/features/compartir/PaginaCompartir";

export const Route = createFileRoute("/_authenticated/app/compartir")({
  // `?fallo=…`: lo pone el service worker (o el servidor) si no pudo recibir lo compartido.
  validateSearch: (search: Record<string, unknown>): { fallo?: string } => ({
    fallo: typeof search.fallo === "string" ? search.fallo : undefined,
  }),
  component: RutaCompartir,
});

function RutaCompartir() {
  const { fallo } = Route.useSearch();
  return <PaginaCompartir fallo={fallo} />;
}
